var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMakePrivate = function SvgMakePrivate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 12.6667C7.43869 12.6667 6.87669 12.548 6.33069 12.3367",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9213 8.31201C12.66 10.6447 10.33 12.6667 8 12.6667",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7194 5.94727C13.18 6.4866 13.5894 7.0746 13.9214 7.6886C14.026 7.8826 14.026 8.11793 13.9214 8.31193",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 12.6666L12.6667 3.33325",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51539 9.48466C5.69539 8.66466 5.69539 7.33466 6.51539 6.51466C7.33539 5.69466 8.66539 5.69466 9.48539 6.51466",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3626 4.63725C10.3313 3.83925 9.16529 3.33325 7.99996 3.33325C5.66996 3.33325 3.33996 5.35525 2.07862 7.68859C1.97396 7.88259 1.97396 8.11792 2.07862 8.31192C2.70929 9.47792 3.60662 10.5659 4.63729 11.3633",
    stroke: "#0C547D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMakePrivate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "d51772ac37457b4b31b3485f1ee3a145.svg";